import { Component, Input } from '@angular/core';
import { IEmployee } from '../../models/EmployeeApplication';

@Component({
    selector: 'app-employee-application-person',
    templateUrl: './person.component.html',
    styleUrls: ['./application.component.scss']
})
export class EmployeeApplicationPersonComponent {
    @Input() data: IEmployee;
}
